<app-header></app-header>
<div class="body-consulta" id="page-wrapper">
  <div class="container-fluid">
    <div class="row row-stat">
      <div class="container">
        <div class="panel panel-default">
          <div class="panel-heading noborder">
            <br>
            <form action="">
              <div class="row justify-content-center">
                <h5>Consultar Visitas Cliente</h5>
              </div>
              <hr>
              <div class="row">
                <div class="col-6">
                  <label class="">Tipo Servicio: </label>
                  <select class="form-control" name="Sistemas"
                    [formControl]="fServicio">
                    <option [value]="' '">Todos los Servicios</option>
                    <option [value]="'IN'">IN Instalacion</option>
                    <option [value]="'RE'">RE Reingenieria</option>
                    <option [value]="'CM'">CM Contrato De Mantenimiento</option>
                    <option [value]="'PH'">PH Presupuesto Por Hora</option>
                    <option [value]="'VH'">VH Visita Por Hora</option>
                  </select>
                </div>

                <div class="col-3">
                  <label class="">Desde:</label>
                  <input type="date" class="form-control" placeholder="Fecha Desde" name="Fdesde"
                    [ngModel]="desde" (ngModelChange)="desde = $event">

                </div>
                <div class="col-3">
                  <label class="">Hasta:</label>
                  <input type="date" class="form-control" placeholder="Fecha Hasta" name="Fhasta"
                    [ngModel]="hasta" (ngModelChange)="hasta = $event">
                </div>
              </div>
              <br>
              <div class="row justify-content-end">
                <button class="btn btn-outline-secondary mr-3 mt-3" (click)="getBuscar()">Buscar
                  Visitas</button>
              </div>
              <br>
            </form>
            <br>
            <div class="row ">
              <div class="col-12">
                <lsy-tabla-la *ngIf="controlDameVisitaCliente.visible" [columnas]="dtColumnas"
                  [datosX]="controlDameVisitaCliente.CadOut" barraY='70vh'></lsy-tabla-la>
                <div *ngIf="controlDameVisitaCliente.visible" style="text-align: right;">Total de Horas: {{totalHoras}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>


